<script>
    import ActionBottom from "../widgets/ActionBottom.svelte";
    import { onDestroy } from 'svelte';
    import { onMount } from "svelte";
    import store from 'store';
    import { slide } from 'svelte/transition';
    import { cancalAdd,alertinfo } from '../store.js';
    import copy from 'copy-to-clipboard';
    let allredball = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
    ];
    let allblueball = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
    ];
    export let value;
    export let key;
    export let choose_panel;
    export let action_id;
    let types = ['one','two','three','four','five','six','seven'];
    let saved = false;
    let actions = {
        copiable: false, //是否可复制
        addable: false, //是否可增加
        reducable: false, //是否可减少
        randable: true,//是否可随机
    };
    onMount(() => {
        for(let type of types){
            value[type] = value[type] || [];
        }
    });
    $: {
        let c = 1;
        value.type = 'danshi';
        for(let type of types){
            c = c * value[type].length;
            if(value[type].length > 1){
                value.type = 'fushi'
            }
        }
        if(c > 0){
            actions.copiable = true;
            if(value.nums <= 1){
                actions.addable = true;
                actions.reducable = false;
            }else if(value.nums >= 99){
                actions.addable = false;
                actions.reducable = true;
            }else{
                actions.addable = true;
                actions.reducable = true;
            }
            value.price = c * value.nums * 2;
        }else{
            actions.copiable = false;
            actions.addable = false;
            actions.reducable = false;
            value.price = 0;
        }
    }

    function choose(e, selectedType, ball) {
        let index = selectedType.indexOf(ball);
        if (index != -1) {
            selectedType.splice(index, 1);
        } else {
            selectedType.push(ball);
        }
        value = value;
    }
    const handleStore = () => {
        let savable = false;
        for(let type of types){
            if(value[type].length > 0){
                savable = true;
                value[type].sort((a, b) => {return a - b})
            }
        }
        if(savable == true){
            store.set(key,value)
        }
        choose_panel = 0;
        action_id = key;
	}
    const handleAdd = () => {
        value.nums += 1;
    }
    const handleReduce = () => {
        value.nums -= 1;
    }
    const handleCopy = () => {
        let text = 'https://xh.wangzhanb.com/ \r\n';
        text = text.concat('-----------------\r\n');
        text = text.concat('七星彩选号：\r\n');
        if (value.type == 'fushi') {
            text = text.concat('复式 - ');
            text = text.concat(value.nums + '倍' + '\r\n');
            types.forEach((item,index) => {
                text = text.concat('第'+(index+1)+'位：'+value[item].sort((a, b) => {return a - b}).join('  ')) + '\r\n';
            });
        } else {
            text = text.concat('单式 - ')
            text = text.concat(value.nums + '倍' + '\r\n');
            let temp = '';
            types.forEach((item,index) => {
                if(index < 6){
                    temp = temp.concat(value[item][0]) + '  ';
                }else{
                    temp = temp.slice(0,-1).concat('- ' + value[item][0]);
                }
            });
            text = text.concat(temp)
        }
        copy(text,{
            onCopy: alertinfo.set('内容已复制')
        });
    }
    const handleRand = () => {
        actions.randable = false;
        let timegaps = [1,30,40,50,60,70,80,90,100];
        for (let i=0; i<timegaps.length; i++) {
            setTimeout( function timer() {
                for(let type of types){
                    if(type != 'seven'){
                        value[type] = [app.getRandOne(allredball)]
                    }else{
                        value[type] = [app.getRandOne(allblueball)]
                    }
                }
                if(timegaps.length - 1 == i){
                    actions.randable = true;
                }
            }, i*timegaps[i] ,i);
        }
    }
    onDestroy(() => {
        if(saved == false){
            let savable = false;
            for(let type of types){
                if(value[type].length > 0){
                    savable = true;
                    value[type].sort((a, b) => {return a - b})
                }
            }
            if(savable == true){
                store.set(key,value)
            }else{
                cancalAdd.set(key);
            }
        }
    })
</script>

<div class="xuanhaoqi" transition:slide="{{duration: 200 }}">
    {#each types as type, i}
    {#if type != 'seven'}
    <div class="qdf-list {[1,3,5].indexOf(i) != -1 ? 'qdf-even' : 'qdf-odd'}">
        {#each allredball as ball}
            <span
                ><i
                    on:click={(e) => choose(e, value[type], ball)}
                    class:selected={value[type].indexOf(ball) != -1}
                    >{ball}</i
                ></span
            >
        {/each}
    </div>
    {/if}
    {/each}
    
    <div class="qdf-list qdf-blue">
        {#each allblueball as ball}
            <span
                ><i
                    on:click={(e) => choose(e, value.seven, ball)}
                    class:selected={value.seven.indexOf(ball) != -1}
                    >{ball}</i
                ></span
            >
        {/each}
    </div>
    <ActionBottom price={value.price} bind:nums={value.nums} bind:actions on:store={handleStore} on:copy={handleCopy} on:rand={handleRand} on:add={handleAdd} on:reduce={handleReduce}/>
</div>

<style>
    .xuanhaoqi {
        background-color: #fff;
        box-sizing: border-box;
        padding: 0.5rem 0.1rem 0;
        border-radius: 0.9rem;
        width: calc(100% - 1rem);
        margin: 0.2rem auto 0.56rem;
        position: relative;
    }
    .qdf-list {
        position: relative;
        font-size: 0;
    }

    .qdf-list span {
        display: inline-block;
        width: 10%;
        margin: .1rem 0;
        position: relative;
        vertical-align: middle;
        text-align: center;
    }

    .qdf-list span:before {
        content: "";
        display: inline-block;
        padding-bottom: 100%;
        width: 0.1rem;
        vertical-align: middle;
    }

    .qdf-list i {
        font-style: normal;
        display: inline-flex;
        position: absolute;
        top: 0.1rem;
        left: 0.1rem;
        height: calc(100% - 0.2rem);
        width: calc(100% - 0.2rem);
        box-sizing: border-box;
        border-radius: 50%;
        font-size: 1rem;
        color: #383838;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        user-select: none;
        font-family: "Baloo Chettan 2";
    }

    .qdf-even i {
        background-color: #db8181;
    }

    .qdf-odd i {
        background-color: #fba1a1;
    }

    .qdf-blue i {
        background-color: #ccd1e4;
    }

    .qdf-even i.selected,.qdf-odd i.selected {
        background-color: red;
        color: #fcfcfc;
    }

    .qdf-blue i.selected {
        background-color: blue;
        color: #fcfcfc;
    }
</style>
